import type { Notification } from '@/features/notifications/domain/model/notification';

/** Máximo de notificaciones que se conservan por local. */
export const MAX_NOTIFICATIONS = 50;
/** Filas que se piden al repositorio antes de descartar las vencidas. */
export const FETCH_LIMIT = 80;

export function isActive(notification: Pick<Notification, 'expires_at'>, now: string): boolean {
  return !notification.expires_at || notification.expires_at > now;
}
